import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const CollectionsPage = lazy(() => import('../pages/collections/page'));
const ProductPage = lazy(() => import('../pages/product/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const BlogsPage = lazy(() => import('../pages/blogs/page'));
const BlogDetailPage = lazy(() => import('../pages/blogs/detail/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/collections',
    element: <CollectionsPage />,
  },
  {
    path: '/collections/:category',
    element: <CollectionsPage />,
  },
  {
    path: '/product/:id',
    element: <ProductPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/blogs',
    element: <BlogsPage />,
  },
  {
    path: '/blogs/:slug',
    element: <BlogDetailPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
